import { useBoundField, type FieldProps } from "../field-state";

export function Switch(props: FieldProps<"s-switch">) {
  const { field, error, dismissError, handleBlur } = useBoundField<boolean>();
  return (
    <s-switch
      {...props}
      name={field.name}
      checked={field.state.value}
      error={error}
      onChange={(event) => {
        dismissError();
        field.handleChange(event.currentTarget.checked);
      }}
      onBlur={handleBlur}
    />
  );
}
